import { useTranslate } from '@common/hooks'

import InstructionCarosel from '../InstructionCarosel'
import classNames from './styles.module.scss'

interface IProps {
  onHide: () => void,
}

export default function ModalInstruction({
  onHide,
}: IProps): JSX.Element {
  const { translate } = useTranslate()
  return (
    <div className={classNames.wrapper}>
      <h2 className={classNames.title} data-test="modal-title">
        {translate('Broadcast Overlay Installation')}
      </h2>
      <InstructionCarosel onHide={onHide}/>
    </div>
  )
}
